import script from "./GiftyAppModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftyAppModal.vue?vue&type=script&setup=true&lang=js"

import "./GiftyAppModal.vue?vue&type=style&index=0&id=853abeb8&lang=css"

const __exports__ = script;

export default __exports__